<template>
  <div :class="['wrapper', classes]" >
    <dash-header :user="users"></dash-header>
    <sidebar />
      <v-main>
        <div class="content-wrapper">
          <section class="content-header">
            <div class="content-header-top">
              <h1>
                {{$route.name.toUpperCase() }}
                <!-- <small>{{ $route.meta.description }}</small> -->
              </h1>
      
              <ol class="breadcrumb">
                <li>
                  <a href="javascript:;">
                    <i class="fa fa-home"></i> Home
                  </a>
                </li>
                <li class="active">{{$route.name.toUpperCase()}}</li>
              </ol>
            </div>
            <h2>
              <div class="toast" role="alert" aria-live="assertive" aria-atomic="true">
              </div>
            </h2>
          </section>
          <router-view></router-view>
        </div>
        <dash-footer></dash-footer>
      </v-main>
    </div>
</template>

<script>
import config from '../config'
import DashFooter from './layout/DashFooter'
import DashHeader from './layout/DashHeader'
import Sidebar from './layout/Sidebar'
import 'hideseek'

export default {
  name: 'Dash',
  components: {
    DashFooter,
    DashHeader,
    Sidebar
  },
  data: function () {
    return {
      // section: 'Dash',
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      }
    }
  },
  computed: {
    users () {
      return {
        name: this.$store.state.user.name,
        username: this.$store.state.user.username
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Dash.vue?49da3cae